"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkOX4QNVYYjs = require('./chunk-OX4QNVYY.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

var _jsxruntime = require('react/jsx-runtime');

var c = _chunkOX4QNVYYjs.c.call(void 0, {
  name: "MenuHamburgerIconMedium",
  size: "Medium",
  svg: _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, "rect", {
      height: "2",
      width: "21",
      x: "4",
      y: "6"
    }), _jsxruntime.jsx.call(void 0, "rect", {
      height: "2",
      width: "21",
      x: "4",
      y: "14"
    }), _jsxruntime.jsx.call(void 0, "rect", {
      height: "2",
      width: "21",
      x: "4",
      y: "22"
    })]
  }),
  svgElements: ["rect"]
});

exports.MenuHamburgerIconMedium = c;